import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Container from 'components/Ui/Container';
import ScreenReader from 'components/Ui/ScreenReader';
import { Div, H1 } from 'components/Ui';
import { ThumbUpWhite } from 'images';
import { injectVariables } from 'utils/translation';
import { getRegionalBrandName } from 'utils/domainHelper';
import styles from './styles.scss';

const Header = ({ cartSummary, acquisitionVariables, ssrReqRoute }) => {
  const [isCostco, setIsCostco] = useState(false);
  const regionalBrandName = getRegionalBrandName(ssrReqRoute, 2);
  const [teleSaleNumber, setTeleSaleNumber] = useState();

  const showPromoBanner =
    cartSummary.promotionId &&
    !!cartSummary.discount &&
    cartSummary.discount > 0;

  useEffect(() => {
    setIsCostco(window.isCostcoWater);
  }, []);

  useEffect(() => {
    setTeleSaleNumber(
      injectVariables(
        '{callToOrder}',
        regionalBrandName,
        acquisitionVariables,
        'C1',
      ),
    );
  }, [acquisitionVariables]);

  return (
    <Fragment>
      {showPromoBanner && (
        <div className={styles.promoApplied}>
          <div className={styles.container}>
            <div className={styles.title}>
              <img src={ThumbUpWhite} alt="" className={styles.icon} />
              <Div className={styles.label}>You did it!</Div>
            </div>
            <Div className={styles.note}>
              {`Your order qualifies for $${cartSummary.discount} off along
              with sign up.`}
            </Div>
            <Div className={styles.info}>Discount shown below.</Div>
          </div>
        </div>
      )}
      <div className={styles.header}>
        <Container value="Water Cart Header" className={styles.container}>
          <H1 className={styles.title}>My cart</H1>
          <Div className={styles.deliverySchedule} ariaHidden={'true'}>
            You are on a 2-week recurring schedule.
            <sup className={styles.supScript}> 1</sup>
          </Div>
          <ScreenReader>
            You are on a 2-week recurring schedule. Additional Note: Some areas
            subject to 4-week delivery based on service routes.
          </ScreenReader>
          {!isCostco ? (
            <Div className={styles.note}>
              Please make sure to select the amount of water you will need for a
              2-week period until your next delivery.
            </Div>
          ) : (
            <Div className={styles.note}>
              Be sure to select the correct amount of water you&apos;ll need
              until your next delivery.
            </Div>
          )}
          {!isCostco && teleSaleNumber && (
            <div className={styles.teleMarketing}>
              <Div>teleMarketingText</Div>
              <a href={`tel:${teleSaleNumber}`}>{teleSaleNumber}</a>
            </div>
          )}
        </Container>
      </div>
    </Fragment>
  );
};

Header.propTypes = {
  cartSummary: PropTypes.object,
  acquisitionVariables: PropTypes.array,
};

export default Header;
